import { useEffect } from "react";
import PropTypes from "prop-types";

const PageTitle = ({ title, children }) => {
  useEffect(() => {
    document.title = title || "Connected Buildings";
  }, [title]);

  return children;
};

PageTitle.propTypes = {
  children: PropTypes.element.isRequired,
  title: PropTypes.string
};

export default PageTitle;
